module.exports = __webpack_public_path__ + "static/media/attach-pin.9c5e3d09.svg";